import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

function NotFound() {
  return (
    <PageHero
      eyebrow="404"
      title="Page not found"
      subtitle="The page you're looking for doesn't exist."
      actions={
        <Link to="/" className="btn btn-primary">
          Back to home
        </Link>
      }
    />
  );
}

export default NotFound;
